import React from "react";
import {
  User, Mail, Phone, Calendar, FileText, MapPin,
  Globe, Building, Users, CheckCircle, Award, Activity,
} from "lucide-react";
import { EmptyCard } from "../../../components/EmptyCard";

const DetailsTab = ({
  styles,
  theme,
  isRTL,
  screenSize,
  employeeData,
  recentActivities,
  handleMouseEnter,
  handleMouseLeave,
  t,
}) => {
  const iconSize = screenSize.isMobile ? 18 : 24;
  const smallIcon = 18;

  const InfoItem = ({ icon: Icon, label, value }) => (
    <div style={styles.infoItem}>
      <div style={styles.infoIcon}><Icon size={smallIcon} /></div>
      <div style={styles.infoContent}>
        <div style={styles.infoLabel}>{label}</div>
        <div style={styles.infoValue}>{value}</div>
      </div>
    </div>
  );

  return (
    <div style={styles.contentGrid}>
      {/* ── Left column ────────────────────────────────────────────── */}
      <div>
        

        {/* Render card manually so we can put the icon in the title */}
        <div style={styles.card} >
          <h3 style={styles.cardTitle}>
            <User size={iconSize} />
            {t("personalInformation")}
          </h3>
          <div style={styles.infoGrid}>
            <InfoItem icon={Mail}        label={t("emailAddress")}    value={employeeData.email} />
            <InfoItem icon={Phone}       label={t("phoneNumber")}     value={employeeData.phone} />
            <InfoItem icon={Calendar}    label={t("dateOfBirth")}
              value={employeeData.birthDate ? new Date(employeeData.birthDate).toLocaleDateString(isRTL ? "ar-EG" : "en-US") : "--"} />
            <InfoItem icon={FileText}    label={t("nationalId")}      value={employeeData.nationalId} />
            <InfoItem icon={MapPin}      label={t("address")}         value={employeeData.address} />
            <InfoItem icon={Phone}       label={t("emergencyContact")} value={employeeData.emergencyContact} />
          </div>
        </div>

        {/* Languages */}
        <div style={styles.card} >
          <h3 style={styles.cardTitle}>
            <Globe size={iconSize} />
            {t("languages")}
          </h3>
          <div style={styles.skillsGrid}>
            {employeeData.languages.map((lang, i) => (
              <div key={i} style={{ ...styles.skillTag, background: "rgba(139,92,246,0.2)", color: "#a78bfa" }}>
                {lang}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Right column ───────────────────────────────────────────── */}
      <div>
        {/* Employment Details */}
        <div style={styles.card} 
        // onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}
        >
          <h3 style={styles.cardTitle}>
            <Building size={iconSize} />
            {t("employmentDetails")}
          </h3>
          <div style={styles.infoGrid}>
            <InfoItem icon={Building}     label={t("employeeId")}       value={employeeData.employeeId} />
            <InfoItem icon={Calendar}     label={t("joinDate")}
              value={employeeData.joinDate ? new Date(employeeData.joinDate).toLocaleDateString(isRTL ? "ar-EG" : "en-US") : "--"} />
            <InfoItem icon={Users}        label={t("manager")}          value={employeeData.manager} />
            <InfoItem icon={MapPin}       label={t("workLocation")}     value={employeeData.workLocation} />
            <InfoItem icon={CheckCircle}  label={t("employmentStatus")} value={employeeData.status} />
          </div>
        </div>

        {/* Certifications */}
        <div style={styles.card}
        //  onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}
         >
          <h3 style={styles.cardTitle}>
            <Award size={iconSize} />
            {t("certifications")}
          </h3>
          <div style={styles.skillsGrid}>
            {employeeData.certifications.map((cert, i) => (
              <div key={i} style={{ ...styles.skillTag, background: "rgba(16,185,129,0.2)", color: "#34d399" }}>
                {cert}
              </div>
            ))}
          </div>
        </div>

        {/* Recent Activities */}
        <div style={styles.card}
        //  onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}
         >
          <h3 style={styles.cardTitle}>
            <Activity size={iconSize} />
            {t("recentActivities")}
          </h3>
          <div style={{ maxHeight: screenSize.isMobile ? "300px" : "400px", overflowY: "auto" }}>
            {recentActivities.map((activity, i) => (
              <div key={i} style={styles.activityItem}>
                <div style={{
                  ...styles.activityIcon,
                  background: activity.importance === "high" ? "rgba(239,68,68,0.2)" : "rgba(59,130,246,0.2)",
                  color: activity.importance === "high" ? "#ef4444" : "#3b82f6",
                }}>
                  <activity.icon size={screenSize.isMobile ? 14 : 16} />
                </div>
                <div style={styles.activityContent}>
                  <p style={styles.activityText}>{activity.action}</p>
                  <p style={styles.activityTime}>{activity.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;